import { motion } from "framer-motion";

const About = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .about-font {
          font-family:'Plus Jakarta Sans',sans-serif;
        }
      `}</style>

      <section className="about-font py-16 sm:py-20 lg:py-[80px] overflow-hidden">

        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center px-5 sm:px-8 lg:px-10">

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className="w-full"
          >
            <img
              src="https://hvac.com.pk/wp-content/uploads/2024/03/IMG-20240307-WA0014-min-768x512.webp"
              alt="HVAC Cooling System"
              className="w-full h-[260px] sm:h-[400px] lg:h-[420px] object-cover rounded-2xl sm:rounded-3xl shadow-xl"
            />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className="w-full"
          >

            <p className="text-xs sm:text-sm text-gray-500 uppercase tracking-[4px] sm:tracking-[6px]">
              About Us
            </p>

            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold mt-4 leading-tight text-[#1f4ba5]">
              Reliable Cooling System Engineering
            </h2>

            <p className="text-gray-600 mt-5 sm:mt-6 leading-7 text-sm sm:text-[15px] lg:text-base">
              We are a trusted manufacturer and supplier of high-quality HVAC
              coils and cooling solutions, delivering reliable performance and
              long-lasting durability. With a strong focus on engineering
              excellence, we design products that meet the demands of modern
              air conditioning and refrigeration systems.
              <br />
              <br />
              Our commitment is to provide efficient, energy-saving, and
              cost-effective coil solutions for residential, commercial, and
              industrial applications. Every product is carefully manufactured
              and tested to ensure maximum performance, reliability, and
              customer satisfaction.
            </p>

          </motion.div>

        </div>

      </section>
    </>
  );
};

export default About;